var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('VueFeedback',{attrs:{"type":"error"}},[_c('h3',{attrs:{"slot":"feedback-title"},slot:"feedback-title"},[_vm._v("Hoppá!")]),_c('p',{attrs:{"slot":"feedback-content"},slot:"feedback-content"},[_vm._v("Technikai hiba történt, kérjük próbálja újra!")])])
}
var staticRenderFns = []

export { render, staticRenderFns }